import { _, moment, Radio, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import { Dependencies, Backform, Biscuit, Notification } from "../../utils";

import OffCanvasBehavior from "../../behaviors/Behavior.OffCanvas";

import Users from "../../collections/Users";
import Pricetariffs from "../../collections/Pricetariffs";
import OffCanvasPricediscountsFormTpl from "../../templates/pricediscounts/OffCanvasPricediscountsFormTpl.html";

import Pricediscount from "../../models/Pricediscount";

export default InboomaBaseView.extend({
  template: OffCanvasPricediscountsFormTpl,
  parentView: "pricediscounts", // For routing back
  el: "#offCanvasPricediscountsForm",

  _throwUsernameUniqueError() {
    new Notification({
      message: this.t("user_error_unique_username"),
      duration: 5000,
      type: "warning",
      closeable: true,
      icon: "fi fi-torso",
    });

    this.$el.find('input[name="username"]').addClass("is-invalid-input");
  },

  _throwMailUniqueError() {
    new Notification({
      message: this.t("user_error_unique_mail"),
      duration: 5000,
      type: "warning",
      closeable: true,
      icon: "fi fi-mail",
    });

    this.$el.find('input[name="email"]').addClass("is-invalid-input");
  },

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      openCanvas: (view) => {
        if (typeof view.options.openCanvas != "undefined") {
          return view.options.openCanvas;
        }
        return true;
      },
      beforeSave: (model) => {
        if (model.get("id") === null) {
          model.set("client_id", Number(Biscuit.get("user.client_id")));
          model.set("discount_type", Biscuit.get("type"));
          if (model.get("active") === true) {
            model.set("active", 1);
          } else {
            model.set("active", 0);
          }

          if (model.get("combineable") === true) {
            model.set("combineable", 1);
          } else {
            model.set("combineable", 0);
          }
        }
      },
      afterSaveSuccess: (model, view, response) => {
        // POST /users/userRegistration returns data[0]
        // POST /users returns data

        if (typeof response.data[0] != "undefined") {
          model = new Pricediscount(response.data[0]);
        } else {
          model = new Pricediscount(model.toJSON());
        }

        if (model.get("created") == "" || _.isNull(model.get("created"))) {
          model.set("created", moment().toISOString());
        }

        view.collection.set(model, { add: true, merge: true, remove: false });

        new Notification({
          message:
            view.t(view.isNew ? "saved_${a}" : "updated_${a}", { a: view.t("user") }, "capital") +
            " " +
            model.get("username") +
            ". " +
            (view.isNew ? view.t("user_registration_mail_sent") : ""),
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });

        // if model.get('role') == manager || admin
        // Backbone.history.navigate('users/staff');
      },
      afterSaveError: (model, view, response) => {
        if (typeof response.data != "undefined") {
          if (typeof response.responseJSON.data.errors.username != "undefined") {
            view._throwUsernameUniqueError();
          }

          if (typeof response.responseJSON.data.errors.email != "undefined") {
            view._throwMailUniqueError();
          }
        } else {
          new Notification({
            message: view.t("request_error"),
            duration: 5000,
            type: "warning",
            closeable: true,
            icon: "fi fi-x",
          });
        }
      },
    },
  ],

  initialize() {
    this.isNew = this.model.get("id") == "";

    Biscuit.set("type", this.options.type);

    new Dependencies({
      pricetariffs: new Pricetariffs(),
    }).then(() => {
      this.pricetariffs = Radio.channel("pricetariffs").request("get:data");
      let pricetariffs_arr = [
        {
          label: "",
          value: "",
        },
      ];
      _.each(this.pricetariffs.models, (pricetariff) => {
        pricetariffs_arr.push({
          label: pricetariff.get("name"),
          value: pricetariff.get("id"),
        });
      });

      this.pricetariffs_arr = pricetariffs_arr;
      if (this.options.type == "user") {
        new Dependencies({
          users: new Users(),
        }).then(() => {
          this.users = Radio.channel("users").request("get:data");
          let users_arr = [
            {
              label: "",
              value: "",
            },
          ];
          _.each(this.users.models, (user) => {
            users_arr.push({
              label: user.get("first_name") + " " + user.get("last_name"),
              value: user.get("id"),
            });
          });
          this.users_arr = users_arr;
          this.render();
        });
      } else {
        this.render();
      }
    });
  },

  templateContext() {
    return {
      created_printable: moment(this.model.get("created")),
      modified_printable: moment(this.model.get("modified")),
      type: this.options.type,
    };
  },

  onRender() {
    const that = this;

    let pricetariffs_arr = that.pricetariffs_arr;

    if (that.options.type == "user") {
      let users_arr = that.users_arr;
      var fields = [
        {
          name: "user_id",
          label: this.t("user", null, "capital"),
          control: "selector",
          options: users_arr,
          disabled: false,
          required: true,
          size: {
            large: "4",
          },
        },
        {
          name: "pricetariff_id",
          label: this.t("pricetariff", null, "capital"),
          control: "selector",
          options: pricetariffs_arr,
          disabled: false,
          required: true,
          size: {
            large: "4",
          },
        },
        {
          name: "description",
          label: this.t("description", null, "capital"),
          control: "input",
          helpMessage: that.model.get("description") == "" ? this.t("no_special_char_allowed") : "",
          required: true,
          size: {
            large: "12",
          },
        },
        {
          name: "discount_amount",
          label: this.t("discount_amount", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "discount_percent",
          label: this.t("discount_percent", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          // @TODO begin & end: make require & controle variable
          name: "valid_from",
          label: this.t("valid_from", null, "capital"),
          control: "datetimepicker",
          //required: true,
          minDate: null,
          size: {
            small: "12",
            large: "6",
          },
          triggerPicker: "valid_to",
        },
        {
          name: "valid_to",
          label: this.t("valid_to", null, "capital"),
          minDate: null,
          control: "datetimepicker",
          //required: true,
          size: {
            small: "12",
            large: "6",
          },
        },
        { control: "spacer" },
        {
          name: "active",
          label: this.t("active", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "combineable",
          label: this.t("combineable", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
      ];
      that.form = new Backform.Form({
        el: that.$el.find("form"),
        model: that.model,
        fields: fields,
        events: {
          'keypress input[name="username"]': function (e) {
            // Do NOT allow special chars || space
            // BUT allow Umlaut
            let k = e.which;
            return (
              (k > 64 && k < 91) ||
              (k > 96 && k < 123) ||
              k == 8 ||
              (k >= 48 && k <= 57) ||
              k == 0 ||
              k == 186 ||
              k == 192 ||
              k == 222 ||
              k == 228 ||
              k == 252 ||
              k == 246
            );
          },
        },
      });

      that.form.render();
    } else if (that.options.type == "client") {
      let booking_types = [
        { label: that.t("reservations", null, "capital"), value: "reservation" },
        { label: that.t("orders", null, "capital"), value: "order" },
      ];
      var fields = [
        {
          name: "description",
          label: this.t("description", null, "capital"),
          control: "input",
          helpMessage: that.model.get("description") == "" ? this.t("no_special_char_allowed") : "",
          required: true,
          size: {
            large: "8",
          },
        },
        {
          name: "pricetariff_id",
          label: this.t("pricetariff", null, "capital"),
          control: "selector",
          options: pricetariffs_arr,
          disabled: false,
          required: true,
          size: {
            large: "4",
          },
        },
        {
          name: "count_units",
          label: this.t("count_units", null, "capital"),
          control: "input",
          required: true,
          size: {
            small: "3",
          },
        },
        {
          name: "booking_type",
          label: this.t("booking_type", null, "capital"),
          control: "selector",
          required: true,
          options: booking_types,
          size: {
            small: "9",
          },
        },
        {
          name: "discount_amount",
          label: this.t("discount_amount", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "discount_percent",
          label: this.t("discount_percent", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          // @TODO begin & end: make require & controle variable
          name: "valid_from",
          label: this.t("valid_from", null, "capital"),
          control: "datetimepicker",
          //required: true,
          minDate: null,
          size: {
            small: "12",
            large: "6",
          },
          triggerPicker: "valid_to",
        },
        {
          name: "valid_to",
          label: this.t("valid_to", null, "capital"),
          minDate: null,
          control: "datetimepicker",
          //required: true,
          size: {
            small: "12",
            large: "6",
          },
        },
        {
          name: "active",
          label: this.t("active", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "combineable",
          label: this.t("combineable", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
      ];
      that.form = new Backform.Form({
        el: that.$el.find("form"),
        model: that.model,
        fields: fields,
        events: {
          'keypress input[name="username"]': function (e) {
            // Do NOT allow special chars || space
            // BUT allow Umlaut
            let k = e.which;
            return (
              (k > 64 && k < 91) ||
              (k > 96 && k < 123) ||
              k == 8 ||
              (k >= 48 && k <= 57) ||
              k == 0 ||
              k == 186 ||
              k == 192 ||
              k == 222 ||
              k == 228 ||
              k == 252 ||
              k == 246
            );
          },
        },
      });

      that.form.render();
    } else if (that.options.type == "number") {
      let booking_types = [
        { label: that.t("reservations", null, "capital"), value: "reservation" },
        { label: that.t("orders", null, "capital"), value: "order" },
      ];
      var fields = [
        {
          name: "description",
          label: this.t("description", null, "capital"),
          control: "input",
          helpMessage: that.model.get("description") == "" ? this.t("no_special_char_allowed") : "",
          required: true,
          size: {
            large: "8",
          },
        },
        {
          name: "pricetariff_id",
          label: this.t("pricetariff", null, "capital"),
          control: "selector",
          options: pricetariffs_arr,
          disabled: false,
          required: true,
          size: {
            large: "4",
          },
        },
        {
          name: "discount_nbr",
          label: this.t("discount_number", null, "capital"),
          control: "input",
          required: true,
          size: {
            small: "9",
          },
        },
        {
          name: "discount_amount",
          label: this.t("discount_amount", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "discount_percent",
          label: this.t("discount_percent", null, "capital"),
          control: "input",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "valid_from",
          label: this.t("valid_from", null, "capital"),
          control: "datetimepicker",
          //required: true,
          minDate: null,
          size: {
            small: "12",
            large: "6",
          },
          triggerPicker: "valid_to",
        },
        {
          name: "valid_to",
          label: this.t("valid_to", null, "capital"),
          minDate: null,
          control: "datetimepicker",
          //required: true,
          size: {
            small: "12",
            large: "6",
          },
        },
        {
          name: "active",
          label: this.t("active", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
        {
          name: "combineable",
          label: this.t("combineable", null, "capital"),
          control: "boolean",
          required: false,
          size: {
            small: "6",
          },
        },
      ];
      that.form = new Backform.Form({
        el: that.$el.find("form"),
        model: that.model,
        fields: fields,
        events: {
          'keypress input[name="username"]': function (e) {
            // Do NOT allow special chars || space
            // BUT allow Umlaut
            let k = e.which;
            return (
              (k > 64 && k < 91) ||
              (k > 96 && k < 123) ||
              k == 8 ||
              (k >= 48 && k <= 57) ||
              k == 0 ||
              k == 186 ||
              k == 192 ||
              k == 222 ||
              k == 228 ||
              k == 252 ||
              k == 246
            );
          },
        },
      });

      that.form.render();
    }
  },
});
